import React from 'react';
import { Routes as RouterRoutes, Route, Navigate } from 'react-router-dom';
import Login from '~/pages/Login';
import Aviso from '~pages/Aviso';
import ErrorPage from '~/pages/Errors/e404';

export default function Routes() {
  return (
    <RouterRoutes>
      <Route path="/" element={<Login />} />
      <Route path="/aviso" element={<Aviso />} />
      <Route path="/404" element={<ErrorPage />} />
      <Route path="*" element={<Navigate to="/404" />} />
    </RouterRoutes>
  );
}
